import React from 'react';
import { GraduationCap, Briefcase, Users, Building2, ArrowRight } from 'lucide-react';
export function Services() {
  const mittelstandServices = [{
    title: 'Projektmanagement - der Praxiskurs',
    description: 'Sie haben in Ihre Projektmanagement-Weiterbildung investiert und dennoch erzielen Ihre Projekte nicht den gewünschten Erfolg? Wir zeigen Ihnen was wirklich wichtig ist, damit ihr Projekt neben dem Tagesgeschäft nicht untergeht.',
    icon: GraduationCap,
    price: 'ab 490€',
    priceNote: '+ MwSt.',
    features: ['Kursdauer ein Tag', 'remote oder vor Ort', 'Kurssprache Deutsch oder Englisch', 'frei buchbare Termine oder Termine nach Absprache'],
    link: '#/schulung',
    linkText: 'Termine & Buchung'
  }, {
    title: 'Projektmanagement as a Service',
    description: 'Verschiedene PM-Pakete von klein bis groß für Ihre Projekte zum fairen monatlichen Festpreis. Planbare Kosten, klare Leistungen und messbarer Mehrwert für Ihre Projekte.',
    icon: Briefcase,
    price: 'ab 1.490€',
    priceNote: 'mtl. + MwSt.',
    features: ['belastbare Projektplanung', 'Monatliche Ermittlung des Projektfortschritts und Festlegung des weiteren Vorgehens', 'Projektabschluss und Übergabe ins Tagesgeschäft', 'Dokumentation nach Kundenstandard oder im ellnerconsultancy Format'],
    link: '#/pmaas',
    linkText: 'Zu den Paketen'
  }];
  return <section id="services" className="py-24 bg-slate-50" data-id="element-107">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-109">
          <h2 className="text-blue-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-110">
            Unsere Expertise
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-111">
            Maßgeschneiderte Lösungen
          </h3>
          <p className="text-lg text-slate-600" data-id="element-112">
            Wir unterstützen Sie genau dort, wo Sie uns brauchen. Mit Erfahrung,
            Methodik und Leidenschaft.
          </p>
        </div>

        <div className="space-y-12" data-id="element-113">
          {/* Mittelstand Gruppe - HIGHLIGHTED */}
          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl shadow-xl border-2 border-blue-200 p-8 lg:p-10 relative overflow-hidden" data-id="element-114">
            {/* Decorative element */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-blue-100 rounded-full opacity-20 -mr-32 -mt-32" data-id="element-115"></div>

            <div className="flex items-start gap-4 mb-8 relative z-10" data-id="element-116">
              <div className="w-14 h-14 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg" data-id="element-117">
                <Building2 size={28} className="text-white" strokeWidth={1.5} data-id="element-118" />
              </div>
              <div data-id="element-119">
                <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2" data-id="element-120">
                  Sie starten in die Projektarbeit? Ihre Projekte laufen
                  parallel zum Tagesgeschäft?
                </h3>
                <p className="text-slate-700 font-medium" data-id="element-121">
                  Wir helfen Ihnen mit Aufbau und Unterstützung Ihrer
                  Projektmanagement-Kapazitäten
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 relative z-10" data-id="element-122">
              {mittelstandServices.map((service, index) => <div key={index} className="bg-white p-8 rounded-2xl border-2 border-blue-100 shadow-lg hover:shadow-xl hover:border-blue-300 transition-all duration-300 flex flex-col group relative overflow-hidden" style={index === 0 ? {
              backgroundImage: `linear-gradient(to bottom, rgba(210, 230, 255, 0.7), rgba(255, 255, 255, 0.9)), url('https://cdn.magicpatterns.com/uploads/8vpFevfH79cCdn4rsXtCfk/PM-Schulung.jpg')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            } : index === 1 ? {
              backgroundImage: `linear-gradient(to bottom, rgba(210, 230, 255, 0.7), rgba(255, 255, 255, 0.8)), url('https://cdn.magicpatterns.com/uploads/689pB46xBi4vbQiBQXS9B5/PMaaS.jpg')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center top'
            } : undefined} data-id="element-123">
                  <div className="flex items-start justify-between mb-6 relative z-10" data-id="element-124">
                    <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center text-white shadow-md group-hover:scale-110 transition-transform" data-id="element-125">
                      <service.icon size={28} strokeWidth={1.5} data-id="element-126" />
                    </div>
                    {/* Price Badge - PROMINENT */}
                    <div className="bg-gradient-to-br from-blue-600 to-blue-700 text-white px-5 py-3 rounded-xl shadow-lg" data-id="element-127">
                      <div className="text-2xl font-bold leading-tight" data-id="element-128">
                        {service.price}
                      </div>
                      <div className="text-xs opacity-90 font-medium" data-id="element-129">
                        {service.priceNote}
                      </div>
                    </div>
                  </div>

                  <h4 className="text-xl font-bold text-slate-900 mb-4 group-hover:text-blue-700 transition-colors relative z-10" data-id="element-130">
                    {service.title}
                  </h4>
                  <p className="font-semibold text-slate-600 mb-6 leading-relaxed flex-grow relative z-10" data-id="element-131">
                    {service.description}
                  </p>
                  <ul className="space-y-3 mb-8 relative z-10" data-id="element-132">
                    {service.features.map((feature, idx) => <li key={idx} className="flex items-center text-sm font-semibold text-slate-600" data-id="element-133">
                        <span className="w-2 h-2 bg-blue-500 rounded-full mr-3 flex-shrink-0" data-id="element-134" />
                        {feature}
                      </li>)}
                  </ul>

                  {service.link && <a href={service.link} className="inline-flex items-center justify-center w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors group-hover:shadow-md relative z-10" data-id="element-135">
                      {service.linkText} <ArrowRight className="ml-2 w-5 h-5" data-id="element-136" />
                    </a>}
                </div>)}
            </div>
          </div>

          {/* Freelance Service */}
          <div className="rounded-2xl shadow-sm p-8 lg:p-10 text-white relative overflow-hidden" style={{
          backgroundImage: `linear-gradient(to bottom, rgba(30, 58, 138, 0.70), rgba(30, 58, 138, 0.75)), url('https://cdn.magicpatterns.com/uploads/nPgEbQFwqTmJqS6rSkiFmz/shutterstock_2200154363_Kopie.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }} data-id="element-137">
            <div className="flex items-start gap-4 mb-8 relative z-10" data-id="element-138">
              <div className="w-12 h-12 bg-blue-800 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-139">
                <Users size={24} strokeWidth={1.5} data-id="element-140" />
              </div>
              <div data-id="element-141">
                <h3 className="text-2xl font-bold mb-2" data-id="element-142">
                  Enterprise Projektmanagement
                </h3>
                <p className="text-blue-100" data-id="element-143">
                  IT-Projekte für Banken und Großunternehmen
                </p>
              </div>
            </div>

            <div className="p-6 rounded-xl relative z-10" data-id="element-144">
              <p className="text-blue-100 mb-6 leading-relaxed" data-id="element-145">
                Erfahrene Experten für IT-Projekte in Banken und Großunternehmen.
                Flexibel, skalierbar und bedarfsgerecht.
              </p>
              <ul className="space-y-3" data-id="element-146">
                {['Senior Projekt-Manager', 'Interim-Manager', 'Projektortfolio-Manager', 'Projekt Coach'].map((feature, idx) => <li key={idx} className="flex items-center text-blue-100" data-id="element-147">
                    <span className="w-1.5 h-1.5 bg-blue-300 rounded-full mr-3" data-id="element-148" />
                    {feature}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}